// Tipos para el módulo de Configuración de Campañas

// ============================================================================
// LABORATORIOS (MarcaPrincipal)
// ============================================================================

export interface Laboratorio {
  id: number
  nombre: string
  descripcion: string | null
  activo: boolean
  fecha_creacion: string
  grupo_id: number
  grupo_nombre: string | null
}

export interface LaboratorioCreate {
  nombre: string
  descripcion?: string
  activo?: boolean
  grupo_id: number
}

export interface LaboratorioUpdate {
  nombre?: string
  descripcion?: string
  activo?: boolean
}

// ============================================================================
// MARCAS (MarcaSecundaria)
// ============================================================================

export interface Marca {
  id: number
  nombre: string
  descripcion: string | null
  activo: boolean
  fecha_creacion: string
  marca_principal_id: number
  marca_principal_nombre: string | null
}

export interface MarcaCreate {
  nombre: string
  descripcion?: string
  activo?: boolean
  marca_principal_id: number
}

export interface MarcaUpdate {
  nombre?: string
  descripcion?: string
  activo?: boolean
  marca_principal_id?: number
}

// ============================================================================
// CONFIGURACIONES DE CAMPAÑA
// ============================================================================

export interface ConfigCampania {
  id: number
  nombre_campania: string
  nombre_encargado: string
  remitente: string
  target: string
  base_segmentada: string
  activo: boolean
  fecha_creacion: string
  fecha_modificacion: string
  marca_secundaria_id: number
  marca_secundaria_nombre: string | null
}

export interface ConfigCampaniaCreate {
  nombre_campania: string
  nombre_encargado: string
  remitente: string
  target: string
  base_segmentada: string
  activo?: boolean
  marca_secundaria_id: number
}

export interface ConfigCampaniaUpdate {
  nombre_campania?: string
  nombre_encargado?: string
  remitente?: string
  target?: string
  base_segmentada?: string
  activo?: boolean
  marca_secundaria_id?: number
}

// ============================================================================
// CONFIGURACIÓN GENERAL (tipos, formatos, estados)
// ============================================================================

export interface ConfigGeneral {
  id: number
  nombre: string
  descripcion: string | null
  activo: boolean
  fecha_creacion: string
}

export interface ConfigGeneralCreate {
  nombre: string
  descripcion?: string
  activo?: boolean
}

export interface ConfigGeneralUpdate {
  nombre?: string
  descripcion?: string
  activo?: boolean
}

export type ConfigGeneralEntity =
  | 'tipos-campania'
  | 'formatos-campania'
  | 'estados-contenido'
  | 'estados-envio'
  | 'estados-reporte'
  | 'estados-aprobacion'
  | 'tipos-envio'

export const CONFIG_GENERAL_LABELS: Record<ConfigGeneralEntity, string> = {
  'tipos-campania': 'Tipos de Campana',
  'formatos-campania': 'Formatos de Campana',
  'estados-contenido': 'Estados de Contenido',
  'estados-envio': 'Estados de Envio',
  'estados-reporte': 'Estados de Reporte',
  'estados-aprobacion': 'Estados de Aprobacion',
  'tipos-envio': 'Tipos de Envio',
}

// ============================================================================
// BENCHMARKS
// ============================================================================

export interface Benchmark {
  id: number
  categoria: string
  tasa_entrega: number
  tasa_aperturas: number
  tasa_clics: number
  activo: boolean
  descripcion: string | null
  fecha_creacion: string
  fecha_modificacion: string
}

export interface BenchmarkCreate {
  categoria: string
  tasa_entrega: number
  tasa_aperturas: number
  tasa_clics: number
  activo?: boolean
  descripcion?: string
}

export interface BenchmarkUpdate {
  categoria?: string
  tasa_entrega?: number
  tasa_aperturas?: number
  tasa_clics?: number
  activo?: boolean
  descripcion?: string
}

// ============================================================================
// VARIACIONES BENCHMARK
// ============================================================================

export interface VariacionBenchmark {
  id: number
  categoria: string
  activo: boolean
  rango_10_min: number
  rango_9_min: number
  rango_8_min: number
  rango_7_min: number
  rango_6_min: number
  rango_5_min: number
  rango_4_min: number
  rango_3_min: number
  rango_2_min: number
  peso_entrega: number
  peso_aperturas: number
  peso_clics: number
  calificacion_a_plus_min: number
  calificacion_a_min: number
  calificacion_b_min: number
  calificacion_c_min: number
  fecha_creacion: string
  fecha_modificacion: string
}

export interface VariacionBenchmarkCreate {
  categoria?: string
  activo?: boolean
  rango_10_min?: number
  rango_9_min?: number
  rango_8_min?: number
  rango_7_min?: number
  rango_6_min?: number
  rango_5_min?: number
  rango_4_min?: number
  rango_3_min?: number
  rango_2_min?: number
  peso_entrega?: number
  peso_aperturas?: number
  peso_clics?: number
  calificacion_a_plus_min?: number
  calificacion_a_min?: number
  calificacion_b_min?: number
  calificacion_c_min?: number
}

export interface VariacionBenchmarkUpdate {
  categoria?: string
  activo?: boolean
  rango_10_min?: number
  rango_9_min?: number
  rango_8_min?: number
  rango_7_min?: number
  rango_6_min?: number
  rango_5_min?: number
  rango_4_min?: number
  rango_3_min?: number
  rango_2_min?: number
  peso_entrega?: number
  peso_aperturas?: number
  peso_clics?: number
  calificacion_a_plus_min?: number
  calificacion_a_min?: number
  calificacion_b_min?: number
  calificacion_c_min?: number
}

// ============================================================================
// GRUPOS (para select de laboratorios)
// ============================================================================

export interface GrupoOption {
  id: number
  grupo_id: number
  grupo_nombre: string
  laboratorio: boolean
}
